import {useEffect, useState, useRef} from 'react'
import { useNavigate } from 'react-router-dom';
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined, CloseOutlined, CheckOutlined, SaveOutlined } from '@ant-design/icons';
import {FloatButton, Form, Row, Col, Divider, Button, message, Select, Switch, InputNumber, TimePicker} from 'antd';
import {getData as get, update} from '../../../../apis/ConfiguracionChecadasApi';
import {
  REGLA_3X3_IMSS_OPTIONS,
  MANEJO_HORAS_DOBLES_OPTIONS,
  TIPO_DIA_DESCANSO_OPTIONS,
  TIPO_DIA_FESTIVO_OPTIONS,
  DIAS_SEMANA_OPTIONS,
  REGLA_3X3_IMSS,
  MANEJO_HORAS_DOBLES,
  TIPO_DIA_DESCANSO,
  TIPO_DIA_FESTIVO,
  DIAS_SEMANA
} from '../../../../constants/configuracionChecadas';
import dayjs from 'dayjs';
import _ from 'lodash'

const { Option } = Select;

const routes = [
  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Configuración</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Asistencia</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Configuración de Checadas</span>
      </>
    ),
  }
];

const ConfiguracionChecadasPage = () => {
    let navigate = useNavigate();
    const [ form ] = Form.useForm()
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [setup, setSetup] = useState(false);

    const effectRan = useRef(false);
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
              await refreshData();
              setLoading(false);
            })();
        }
        return () => effectRan.current = true;
    }, []);

    useEffect(() => {
      // Puedes agregar lógica adicional cuando setup cambie
    }, [setup]);
    
    const refreshData = async ()=> {
      const response = await get();
      if(response.ok){
          if(response.payload){
              const formattedData = {
                ...response.payload,
                tiempo_min_entre_checadas: response.payload.tiempo_min_entre_checadas 
                  ? dayjs(response.payload.tiempo_min_entre_checadas, 'HH:mm:ss') 
                  : null
              };
              setData(formattedData);
              setSetup(response.payload.setup);
          } else {
              // Valores por defecto si no existe configuración
              const defaultData = {
                setup: false,
                dias_historia: 3650,
                dia_inicio_semana: DIAS_SEMANA.LUNES,
                seguridad_por_supervisor: false,
                autorizaciones_incidencias: true,
                horas_extras_regla_3x3_imss: REGLA_3X3_IMSS.SOLO_DOBLES,
                manejo_horas_ext_dobles: MANEJO_HORAS_DOBLES.LIMITAR_9_SEMANALES,
                minimo_tiempo_extra: 0.00,
                redondeo_tiempo_extra: 0.00,
                descanso_1: TIPO_DIA_DESCANSO.DESCANSO_TRABAJADO,
                descanso_2: TIPO_DIA_DESCANSO.DESCANSO_TRABAJADO,
                dia_festivo: TIPO_DIA_FESTIVO.FESTIVO_TRABAJADO,
                calcular_prenomina_sin_checada: true,
                solo_checada_entrada_salida: true,
              };
              setData(defaultData);
              message.warning('No se encontró configuración. Por favor configure los valores iniciales.');
          }
      }
    }
    
    const handleOk = async () => {
      try {
        if(setup){
          const values = await form.validateFields();
          if(!values) return;
        }
      } catch (errorInfo) {
          console.log('Failed:', errorInfo);
          return;
      }

      const fields = form.getFieldsValue();
      const payload = {
          ...fields,
          tiempo_min_entre_checadas: fields.tiempo_min_entre_checadas 
            ? fields.tiempo_min_entre_checadas.format('HH:mm:ss') 
            : null
      };
      
      const response = await update(payload);
      if(response.ok){
          message.success('Se guardó correctamente la configuración!');
          await refreshData();
      }
    }

    return <PageApp routes={routes} title={'Configuración de Checadas'}>
      {
        data && 
        <Form 
            layout="vertical" 
            form={form} 
            requiredMark 
            initialValues={data} 
            autoComplete="off"
            onFinish={handleOk}>
            <FloatButton
              tooltip={<div>Guardar</div>} 
              icon={<SaveOutlined />}
              type="primary"
              style={{
                insetInlineEnd: 94,
              }}
              onClick={handleOk}
            />
            <Divider orientation="left" orientationMargin="0">Generales</Divider>
            <Row gutter={16}>
              <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                  <Form.Item
                      name="setup"
                      label="Setup"
                      >
                      <Switch onChange={(value)=>{setSetup(value)}} checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                  </Form.Item>
              </Col>
              <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                <Form.Item
                    name="dias_historia"
                    label="Días de Historia"
                    rules={[
                    {
                        required: setup,
                        message: 'Por favor ingresa los días de historia',
                    },
                    ]}
                >
                  <InputNumber 
                    placeholder="Días de historia" 
                    style={{width: '100%'}}
                    min={0}
                    max={9999}
                  />
                </Form.Item>
              </Col>
              <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                <Form.Item
                    name="dia_inicio_semana"
                    label="Día Inicio Semana"
                    rules={[
                    {
                        required: setup,
                        message: 'Por favor selecciona una opción',
                    },
                    ]}
                >
                  <Select placeholder="Por favor, selecciona una opción">
                    {DIAS_SEMANA_OPTIONS.map((item) => (
                      <Option key={item.value} value={item.value}>{item.text}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                <Form.Item
                    name="tiempo_min_entre_checadas"
                    label="Tiempo Mín. entre checadas"
                    rules={[
                    {
                        required: setup,
                        message: 'Por favor selecciona el tiempo mínimo',
                    },
                    ]}
                >
                  <TimePicker 
                    format="HH:mm" 
                    placeholder="00:05"
                    style={{width: '100%'}}
                  />
                </Form.Item>
              </Col>
              <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                <Form.Item
                    name="seguridad_por_supervisor"
                    label="Seguridad por Supervisor"
                    >
                    <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                </Form.Item>
              </Col>
              <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                <Form.Item
                    name="autorizaciones_incidencias"
                    label="Autorizaciones a Incidencias"
                    >
                    <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                </Form.Item>
              </Col>
            </Row>

            <Divider orientation="left" orientationMargin="0">Configuración Horas Extras</Divider>
            <Row gutter={16}>
              <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                <Form.Item
                    name="horas_extras_regla_3x3_imss"
                    label="Horas Extras p/Regla 3x3 del IMSS"
                    rules={[
                    {
                        required: setup,
                        message: 'Por favor selecciona una opción',
                    },
                    ]}
                >
                  <Select placeholder="Por favor, selecciona una opción">
                    {REGLA_3X3_IMSS_OPTIONS.map((item) => (
                      <Option key={item.value} value={item.value}>{item.text}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                <Form.Item
                    name="manejo_horas_ext_dobles"
                    label="Manejo de Horas Ext. Dobles"
                    rules={[
                    {
                        required: setup,
                        message: 'Por favor selecciona una opción',
                    },
                    ]}
                >
                  <Select placeholder="Por favor, selecciona una opción">
                    {MANEJO_HORAS_DOBLES_OPTIONS.map((item) => (
                      <Option key={item.value} value={item.value}>{item.text}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                <Form.Item
                    name="minimo_tiempo_extra"
                    label="Mínimo Tiempo Extra"
                    rules={[
                    {
                        required: setup,
                        message: 'Por favor ingresa el tiempo mínimo',
                    },
                    ]}
                >
                  <InputNumber 
                    placeholder="0.00" 
                    style={{width: '100%'}}
                    min={0}
                    step={0.01}
                    precision={2}
                  />
                </Form.Item>
              </Col>
              <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                <Form.Item
                    name="redondeo_tiempo_extra"
                    label="Redondeo Tiempo Extra"
                    rules={[
                    {
                        required: setup,
                        message: 'Por favor ingresa el redondeo',
                    },
                    ]}
                >
                  <InputNumber 
                    placeholder="0.00" 
                    style={{width: '100%'}}
                    min={0}
                    step={0.01}
                    precision={2}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Divider orientation="left" orientationMargin="0">Horas Extras en Descansos y Festivos</Divider>
            <Row gutter={16}>
              <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                <Form.Item
                    name="descanso_1"
                    label="Descanso 1"
                    rules={[
                    {
                        required: setup,
                        message: 'Por favor selecciona una opción',
                    },
                    ]}
                >
                  <Select placeholder="Por favor, selecciona una opción">
                    {TIPO_DIA_DESCANSO_OPTIONS.map((item) => (
                      <Option key={item.value} value={item.value}>{item.text}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                <Form.Item
                    name="descanso_2"
                    label="Descanso 2"
                    rules={[
                    {
                        required: setup,
                        message: 'Por favor selecciona una opción',
                    },
                    ]}
                >
                  <Select placeholder="Por favor, selecciona una opción">
                    {TIPO_DIA_DESCANSO_OPTIONS.map((item) => (
                      <Option key={item.value} value={item.value}>{item.text}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                <Form.Item
                    name="dia_festivo"
                    label="Día Festivo"
                    rules={[
                    {
                        required: setup,
                        message: 'Por favor selecciona una opción',
                    },
                    ]}
                >
                  <Select placeholder="Por favor, selecciona una opción">
                    {TIPO_DIA_FESTIVO_OPTIONS.map((item) => (
                      <Option key={item.value} value={item.value}>{item.text}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Divider orientation="left" orientationMargin="0">Opciones Adicionales</Divider>
            <Row gutter={16}>
              <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                <Form.Item
                    name="calcular_prenomina_sin_checada"
                    label="Calcular prenómina a personal que no checa tarjeta"
                    >
                    <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                </Form.Item>
              </Col>
              <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                <Form.Item
                    name="solo_checada_entrada_salida"
                    label="Solo tomar checada de entrada y salida"
                    >
                    <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                </Form.Item>
              </Col>
            </Row>
          </Form>
      }
    </PageApp>
}   

export default ConfiguracionChecadasPage;